import { DataSource, Layout, Panel, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutEdiFuncAckSeg extends Layout {
    panelFASeg: Panel;
    sourceEdiFunctionalSeg: DataSource;
    sourceEdistatus: DataSource;
    sourceViewEdiOrder: DataSource;
    tabFASegment: Tab;
    tabFuncSeg: Tabset;
    table2: Table;
}
